import { CSSProperties } from 'react';
import { BillingCycle } from './UpgradeToProModal/utils';
import useScreen from 'Hooks/useScreen';
import { styx } from 'modules/Utils';
import Colors from 'modules/Colors';

interface BillingCycleToggleProps {
    /** Current selected billing cycle */
    billingCycle: BillingCycle;
    /** Callback when billing cycle changes */
    onBillingCycleChange: (cycle: BillingCycle) => void;
    /** Additional CSS class name */
    className?: string;
    /** Additional inline styles */
    style?: CSSProperties;
}

const BillingCycleToggle = ({
    billingCycle,
    onBillingCycleChange,
    className = '',
    style = {}
}: BillingCycleToggleProps) => {
    const { mobileView } = useScreen();

    return (
        <div
            className={`billingCycleToggleContainer ${className}`}
            style={styx(sty.billingCycleToggleContainer, style)}
        >
            <button
                type="button"
                className="billingCycleToggle"
                style={styx(
                    sty.billingCycleToggle,
                    mobileView ? sty.billingCycleToggle_mobile : {},
                    billingCycle === BillingCycle.MONTHLY ? sty.isSelected : {},
                    { borderRight: `1px solid ${Colors.DARK_DIVIDER_LINE}` },
                    mobileView ? { padding: 8, fontSize: 14 } : {}
                )}
                onClick={() => onBillingCycleChange(BillingCycle.MONTHLY)}
                aria-pressed={billingCycle === BillingCycle.MONTHLY}
            >
                {mobileView ? 'Monthly' : 'Billed monthly'}
            </button>
            <button
                type="button"
                className="billingCycleToggle"
                style={styx(
                    sty.billingCycleToggle,
                    mobileView ? sty.billingCycleToggle_mobile : {},
                    billingCycle === BillingCycle.ANNUAL ? sty.isSelected : {},
                    mobileView ? { padding: 8, fontSize: 14 } : {}
                )}
                onClick={() => onBillingCycleChange(BillingCycle.ANNUAL)}
                aria-pressed={billingCycle === BillingCycle.ANNUAL}
            >
                {mobileView ? 'Annually (20% off)' : 'Billed annually (20% off)'}
            </button>
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    billingCycleToggleContainer: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        border: `1px solid ${Colors.DARK_DIVIDER_LINE}`,
        borderRadius: 100,
        width: 'fit-content',
        overflow: 'hidden',
        alignSelf: 'flex-start',
    },
    billingCycleToggle: {
        padding: '12px 16px',
        fontSize: 16,
        fontWeight: 500,
        color: Colors.textColor,
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        outline: 'none',
    },
    billingCycleToggle_mobile: {
        flex: 1,
        textAlign: 'center',
    },
    isSelected: {
        color: Colors.purple,
        backgroundColor: Colors.purpleLightest,
    },
};

export default BillingCycleToggle;